import local from "@/utils/local";

// 字段排序函数
const compare = property => {
  return function(a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
};

// 获取排序后的列表
export const orderGoodsList = state => {
  return state.goodsList.sort(compare(state.orderBy));
};

// 获取秒杀的小时
export const seckillsHours = state => {
  return state.seckills.deadline.hours < 10
    ? "0" + state.seckills.deadline.hours
    : state.seckills.deadline.hours;
};
// 获取秒杀的分钟
export const seckillsMinutes = state => {
  return state.seckills.deadline.minute < 10
    ? "0" + state.seckills.deadline.minute
    : state.seckills.deadline.minute;
};

// 获取秒杀的秒
export const seckillsSeconds = state => {
  return state.seckills.deadline.seconds < 10
    ? `0${state.seckills.deadline.seconds}`
    : state.seckills.deadline.seconds;
};

// 获取每周特价的小时
export const weeklyHours = state => {
  return state.weekSpecial.weeklyDeadline.hours < 10
    ? "0" + state.weekSpecial.weeklyDeadline.hours
    : state.weekSpecial.weeklyDeadline.hours;
};
// 获取每周特价的分钟
export const weeklyMinutes = state => {
  return state.weekSpecial.weeklyDeadline.minute < 10
    ? "0" + state.weekSpecial.weeklyDeadline.minute
    : state.weekSpecial.weeklyDeadline.minute;
};

// 获取每周特价的秒
export const weeklySeconds = state => {
  return state.weekSpecial.weeklyDeadline.seconds < 10
    ? `0${state.weekSpecial.weeklyDeadline.seconds}`
    : state.weekSpecial.weeklyDeadline.seconds;
};
// token
export const token = state => {
  return state.user.token;
};
// userName
export const userName = state => {
  return state.user.userName;
};
// 购物车数据
export const shoppingCart = state => {
  return state.shoppingCart;
};
// 导航栏数据
export const navData = state => {
  return state.navData;
  // return local.get("nav") ? JSON.parse(local.get("nav")) : [];
};
// 当前导航
export const curNav = state => {
  return state.curNav;
  // return local.get("nav") ? JSON.parse(local.get("nav")) : [];
};
// 容错 isLoading,没有用到
export const isLoading = state => {
  return state.isLoading;
};

// 用户所有信息
export const userAllData = state => {
  return state.user.userAllData;
};
// 刷新右侧购物篮等数量
export const rightRefresh = state => {
  return state.goods.rightRefresh;
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js